import { SystemProps } from '@chakra-ui/react'
import { Box, Flex } from '@core/ui-elements'
import { CSSProperties, FC, ReactElement } from 'react'

export interface IStatCard {
  label?: string | ReactElement | null
  rightSize?: string | ReactElement | null
  content?: string | ReactElement | null
  direction?: SystemProps['flexDirection']
  style?: CSSProperties
}

export const StatCard: FC<IStatCard> = ({
  label,
  rightSize,
  content,
  direction = 'column',
  style,
}) => {
  if (!label && !rightSize && !content) return null

  return (
    <Flex
      data-testid={'stat-card'}
      flexDirection={direction}
      gap={'0.25rem'}
      style={style}
      width={'100%'}
    >
      <Flex
        alignItems={'center'}
        flexDirection={'row'}
        flexWrap={'wrap'}
        justifyContent={'space-between'}
        width={'100%'}
      >
        {label ? (
          <Box fontWeight={'600'} width={rightSize ? undefined : '100%'}>
            {label}
          </Box>
        ) : null}
        {rightSize ? rightSize : null}
      </Flex>

      {content ? (
        <Box textOverflow={'ellipsis'} width={'100%'}>
          {content}
        </Box>
      ) : null}
    </Flex>
  )
}
